import ProfileCard from "@/common/types/ProfileCardInterface";
import {defineStore} from "pinia";

export type RootState = {
    results: ProfileCard[] | null,
    resultsLoading: boolean,
};

export const useResultsStore = defineStore({
    id: "resultsStore",
    state: () => {
        return {
            results: null,
            resultsLoading: false,
        } as RootState
    },
    actions: {
        setResultsLoading(value: boolean): void {
            this.resultsLoading = value
        },
        setResults(cards: ProfileCard[]): void {
            this.results = cards
        },
    },
})